import { DateRange } from 'src/components/DatePicker'

export const getPublishingDates = (): DateRange => {
  const currentDate = new Date()
  const limitDate = new Date()
  const postMaxDate = 59

  currentDate.setDate(currentDate.getDate() - 1)
  limitDate.setDate(limitDate.getDate() + postMaxDate)

  return {
    from: currentDate,
    to: limitDate
  }
}